package org.braunequip.web.util

import org.braunequip.web.util.Constants.ASSETS.STATUS_FUNCTIONING
import org.braunequip.web.util.Constants.ASSETS.STATUS_OUT_OF_SERVICE
import org.braunequip.web.util.Constants.ASSETS.TYPE_OTHER
import org.braunequip.web.util.Constants.ASSETS.TYPE_TRAILER
import org.braunequip.web.util.Constants.ASSETS
import org.braunequip.web.util.Constants.ASSETS.STATUS_UNDER_MAINTENANCE
import org.braunequip.web.util.Constants.ASSETS.TYPE_TRUCK
import kotlin.experimental.and

/*
     -------------------------------------

           TYPE FUNCTIONS

     -------------------------------------
*/
fun parseAssetTypes(value: Short): List<String> {
    val types = mutableListOf<String>()

    if ((value and TYPE_TRUCK) != 0.toShort()) types.add("Truck")
    if ((value and TYPE_TRAILER) != 0.toShort()) types.add("Trailer")
    if ((value and TYPE_OTHER) != 0.toShort()) types.add("Other")

    return types
}

fun getAssetTypesOptions(): List<Pair<Short, String>> {
    return listOf(
        TYPE_TRUCK to "Truck",
        TYPE_TRAILER to "Trailer",
        TYPE_OTHER to "Other"
    )
}

fun getAssetsAsStringList(): List<String> {
    return getAssetTypesOptions().map { it.second }
}

/*
     -------------------------------------

           STATUS FUNCTIONS

     -------------------------------------
*/
fun parseAssetStatus(value: Short): List<String> {
    val statuses = mutableListOf<String>()

    if ((value and STATUS_FUNCTIONING) != 0.toShort()) statuses.add("Functioning")
    if ((value and STATUS_OUT_OF_SERVICE) != 0.toShort()) statuses.add("Out of Service")
    if ((value and STATUS_UNDER_MAINTENANCE) != 0.toShort()) statuses.add("Under Maintenance")

    return statuses
}

fun getAssetStatusOptions(): List<Pair<Short, String>> {
    return listOf(
        STATUS_FUNCTIONING to "Functioning",
        STATUS_OUT_OF_SERVICE to "Out of Service",
        STATUS_UNDER_MAINTENANCE to "Under Maintenance"
    )
}

